"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EchainSystemFormatter = void 0;
const echain_shared_form_validation_1 = require("@igus/echain-shared-form-validation");
const echain_shared_i18n_1 = require("@igus/echain-shared-i18n");
const echain_shared_quantities_1 = require("@igus/echain-shared-quantities");
class EchainSystemFormatter {
    static weightEchainSystem(options) {
        if (options.unitSystem === echain_shared_i18n_1.UnitSystem.imperial) {
            return new echain_shared_form_validation_1.BasicQuantityFormatter({
                unit: echain_shared_quantities_1.WeightUnits.lb,
                unitSystem: echain_shared_i18n_1.UnitSystem.imperial,
                languageTag: options.languageTag,
                roundType: echain_shared_form_validation_1.RoundType.ROUND,
                precision: 2,
            });
        }
        return new echain_shared_form_validation_1.BasicQuantityFormatter({
            unit: echain_shared_quantities_1.WeightUnits.kg,
            unitSystem: echain_shared_i18n_1.UnitSystem.metric,
            languageTag: options.languageTag,
            roundType: echain_shared_form_validation_1.RoundType.ROUND,
            precision: 2,
        });
    }
    static weightEchainSystemWithPackaging(options) {
        return this.weightEchainSystem(options);
    }
}
exports.EchainSystemFormatter = EchainSystemFormatter;
//# sourceMappingURL=EchainSystemFormatter.js.map